import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", null, "Personen", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tickets_reservation = _resolveComponent("tickets-reservation")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.viewProperties.game.reservations, (res) => {
      return (_openBlock(), _createBlock(_component_tickets_reservation, {
        key: `${res.seatid}_${res.registrationid}`,
        res: res,
        viewProperties: $props.viewProperties,
        onDeleteRes: $setup.deleteRes
      }, null, 8, ["res", "viewProperties"]))
    }), 128))
  ], 64))
}